export var restrictions = {
  dataBrowsing: "DATA_BROWSING",
  reportsCreate: "REPORTS_CREATE",
  dataSave: "DATA_SAVE",
  dataDelete: "DATA_DELETE",
  dataModify: "DATA_MODIFY"
};
